import * as yup from 'yup';

export const agentBeneficiaryStateValidationSchemaObject = {
    agent: yup.object()
};
